export default class ImportCart extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
        console.log("connected");
    }

    events() {
        $("#import_cart").on('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            window.HegydCore.initRemoteModal(
                '#modal',
                $("#import_cart").prop('href'),
                null,
                (data) => {
                    location.reload();
                },
                () => {
                     toastr.error('Une erreur s\'est produite');
                }
            );
        });
    }
}
